import { render, staticRenderFns } from "./match-layout.vue?vue&type=template&id=04e1c5ba&scoped=true"
import script from "./match-layout.vue?vue&type=script&lang=js"
export * from "./match-layout.vue?vue&type=script&lang=js"
import style0 from "./match-layout.vue?vue&type=style&index=0&id=04e1c5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1c5ba",
  null
  
)

export default component.exports